<template>
    <section class="panel-body">
        <div class="row">
            <div class="col-12 col-sm-6 col-md-3">
                <div class="info-box bg-dark">
                    <span class="info-box-icon bg-success elevation-1"><i class="text-light fa fa-dollar"></i></span>
                    <div class="info-box-content">
                        <span class="info-box-text"><strong>Meus Pontos </strong>
                            <p class="p-0 m-0 text-center text-bold text-lg">{{auth_user.points}}</p>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
                <div class="info-box bg-dark">
                    <span class="info-box-icon bg-orange elevation-1"><i class="text-light fa fa-tag"></i></span>
                    <div class="info-box-content">
                        <router-link class="text-white" :to="{ name: 'dashboard' }">
                            <span class="info-box-text"><strong>Cupons Disponíveis</strong></span>
                            <p class="p-0 m-0 text-center text-bold text-lg">{{auth_user.tickets_count || 0}}</p>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
                <div class="info-box bg-dark">
                    <span class="info-box-icon bg-danger elevation-1"><i class="fa fa-qrcode"></i></span>
                    <div class="info-box-content ">
                        <router-link class="text-white" :to="{ name: 'vouchers' }">
                            <span class="info-box-text text-white"><strong>Meus Vouchers</strong></span>
                            <p class="p-0 m-0 text-center text-bold text-lg">{{auth_user.vouchers_count || 0}}</p>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
                <div class="info-box bg-dark">
                    <span class="info-box-icon bg-purple elevation-1"><i class="fa fa-file-text"></i></span>
                    <div class="info-box-content ">
                        <router-link class="text-white" :to="{ name: 'extrato' }">
                            <span class="info-box-text "><strong>Ver Extrato</strong></span>
                            <p class="p-0 m-0 text-center text-bold text-lg">{{auth_user.sales_count || 0}}</p>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="timeline">
                    <div class="time-label">
                        <span class="bg-red"><i class="fa fa-clock-o"></i> Histórico de compras</span>
                    </div>
                    <template v-for="(item, i) in history">
                    <div :key="i">
                        <i :class="{'fa-dollar': item.movement == 'C'}" class="fa fa-dollar bg-blue"></i>
                        <div class="timeline-item">
                            <span class="time"><i class="fa fa-clock"></i> {{formatDate(item.created_at)}}</span>
                            <h3 class="timeline-header"><a href="#">{{item.company.company_name}}</a> - {{item.company.company_document}}</h3>
                            <div class="timeline-body">
                                {{item.description}} - ({{item.amount}} {{item.company.points_name}})
                            </div>
                            <div class="timeline-footer">
                            </div>
                        </div>
                    </div>
                    </template>
                    <div>
                        <i class="fa fa-clock-o bg-gray"></i>
                    </div>
                </div>
            </div>

        </div>
    </section>
</template>
<script>
    export default {
        data() {
            return {
                loading: true,
                history: []
            }
        },
        mounted() {
            this.getData();
        },
        methods: {
            getData() {
                this.$store.dispatch("getSalesHistory").then(response => {
                    this.history = response;
                });
            },
        }
    }
</script>

<style>
    .bg-dark {
        background-color: #4b545c !important;
    }
</style>